import axios from "axios";
import { Message } from "element-ui";
import { error } from "@/api/sign";
//import store from '@/store'

// create an axios instance
const service = axios.create({
   // baseURL: "https://lk-api.finelet.com", // api 的 base_url FINELET
 baseURL: 'https://lk-api.isfg.ru', // api 的 base_url ЛАСИР
 // baseURL: 'https://lk-api.finelet.com', // api 的 base_url ЛАСИР
  timeout: 1000000, // request timeoutp
  headers: { "X-Requested-With": "XMLHttpRequest" }
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    return config;
  },
  err => {
    // Do something with request error
    console.log(err); // for debug
    error({ text: err.message });
    Promise.reject(err);
  }
);

// response interceptor
service.interceptors.response.use(
  response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  err => {
    error({ text: err.message });
    console.log("err1", err, err.message); // for debug
    console.log("err2", err, err.response.status); // for debug

    if (
      err.response.status !== 422 &&
      err.response.status !== 403 &&
      err.response.status !== 401
    ) {
      // Message({
      //   message: err.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      error({ text: err.message });
    }

    if (err.response.status === 403) {
      Message({
        message: err.response.data.message,
        type: "error",
        duration: 5 * 1000
      });
      error({ text: err.response.data.message });
    }

    if (err.response.status === 401) {
      Message({
        message:
          "Недостаточно прав для выполнения операции. Перезагрузите браузер",
        type: "error",
        duration: 5 * 1000
      });
      error({
        text: "Недостаточно прав для выполнения операции. Перезагрузите браузер"
      });
    }
    return Promise.reject(err);
  }
);

export default service;
